import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { FluiditeTauxOccupationValues } from '@timechef/core/api';
import { FluiditeDetails } from '../../../state/restaurants.models';

@Component({
  selector: 'app-fluidite-graph',
  templateUrl: './fluidite-graph.component.html',
  styleUrls: ['./fluidite-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FluiditeGraphComponent implements OnChanges {
  @HostBinding('class.mini') @Input() mini = false;
  @Input() fluiditeDetails: FluiditeDetails = {
    rates: [],
  };
  @Input() currentOccupation = FluiditeTauxOccupationValues.Na;
  @Input() isOpen?: boolean;

  @Input()
  graphIsEmpty = false;
  FluiditeTauxOccupationValues = FluiditeTauxOccupationValues;

  ngOnChanges() {
    this.graphIsEmpty = this.fluiditeDetails.rates.every((e) => {
      if (e.lastWeekRate || e.currentRate) return false;

      return true;
    });
  }

  isNotNull(v?: number) {
    return v !== undefined && v !== null;
  }
}
